import type { TExperienceGateProps } from './Experience.types.ts';
import { useExperience } from './use-experience/index.ts';

export const ExperienceGate = ({
  loading,
  failed,
  unconsented,
  children,
}: TExperienceGateProps) => {
  const { isLoadingExperience, experienceError, mainSteps, isConsentRequired } =
    useExperience();

  if (isLoadingExperience) {
    return loading;
  }

  if (experienceError || mainSteps.length === 0) {
    return failed;
  }

  if (isConsentRequired) {
    return unconsented;
  }

  return children;
};
